import { ForwardedRef, forwardRef } from 'react';

import type { ListItemProps } from './ListItem.type';
import * as Styled from './ListItem.styled';

const ListItem = forwardRef(
  (props: ListItemProps, ref: ForwardedRef<HTMLLIElement>) => {
    const { children, disabled, dataTestId, ...rest } = props;
    return (
      <Styled.Item {...rest} ref={ref} data-testid={dataTestId}>
        <Styled.Inner disabled={disabled}>{children}</Styled.Inner>
      </Styled.Item>
    );
  },
);

ListItem.displayName = 'ListItem';

export default ListItem;
